<div class="row">
	<div *ngFor="let _post of posts; let index" class="col-lg-3">
		<kt-content-blog-card
			(btnClick)="postClick.emit($event)"
			[post]="_post"
		></kt-content-blog-card>
	</div>
</div>
